// MOD-7 v2: per-agent Kanban board state persisted in localStorage.
// Stores column order, hidden columns and the chosen sort so each agent keeps
// their own board layout across sessions. Reads are defensive (corrupt/empty
// storage falls back to defaults) so a bad value never breaks the board.

const KEY = (agentId, accountId) =>
  accountId == null
    ? `kanban_state_v2/${agentId}`
    : `kanban_state_v3/${accountId}/${agentId}`;

const DEFAULT_STATE = {
  order: [], // array of label names in display order ('' = "Sin etiqueta" column)
  hidden: [], // label names hidden by the agent
  collapsed: [], // label names minimized by the agent ('' = "Sin etiqueta")
  sortBy: 'last_activity_at_desc',
};

export function loadKanbanState(agentId, accountId) {
  try {
    const raw = localStorage.getItem(KEY(agentId, accountId));
    if (!raw) return { ...DEFAULT_STATE };
    const parsed = JSON.parse(raw);
    return {
      order: Array.isArray(parsed.order) ? parsed.order : [],
      hidden: Array.isArray(parsed.hidden) ? parsed.hidden : [],
      collapsed: Array.isArray(parsed.collapsed) ? parsed.collapsed : [],
      sortBy:
        typeof parsed.sortBy === 'string'
          ? parsed.sortBy
          : DEFAULT_STATE.sortBy,
    };
  } catch (e) {
    return { ...DEFAULT_STATE };
  }
}

export function saveKanbanState(agentId, state, accountId) {
  const merged = { ...DEFAULT_STATE, ...state };
  try {
    localStorage.setItem(KEY(agentId, accountId), JSON.stringify(merged));
  } catch (e) {
    // storage full/unavailable — non-fatal, board still works in-memory
  }
}
